import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-energy-two',
  templateUrl: './energy-two.component.html',
  styleUrls: ['./energy-two.component.sass']
})
export class EnergyTwoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    document.querySelector(".__page-root").scrollIntoView(true);
  }

}
